export default __webpack_public_path__ + "static/media/plane-down-right.38e79138.svg";